<template>
  <div>
    <div class="banner">
      <img class="smallImg" src="./../assets/img/img_bg1_lvshoucamp.png" v-if="activeIndex === 0">
      <img class="bigImg" src="http://www.lvshouhotel.com/lvshouhotel/img_bg_lvshoucamp.png" v-if="activeIndex === 0">
      <img class="smallImg" src="./../assets/img/img_bg2_lvsmaixueguan.png" v-if="activeIndex === 1">
      <img class="bigImg" src="http://www.lvshouhotel.com/lvshouhotel/img_bg_lvsmaixueguan.png" v-if="activeIndex === 1">
    </div>
    <div class="sub-menu-box">
      <ul class="sub-menu clearfix">
        <li class="sub-menu-item fl ta_c" v-for="(item,index) in subMenu" :key="index" :class="activeIndex == index?'sub-menu-item-active':''" @click="changeIndexFn(index)">{{item}}</li>
      </ul>
    </div>
    <lvshouTrainCamp v-if="activeIndex === 0"></lvshouTrainCamp>
    <LvshouMeiXueGuan v-if="activeIndex === 1"></LvshouMeiXueGuan>
  </div>
</template>
<script>
import './../assets/less/pubilc.less'

import lvshouTrainCamp from "@/components/Beauty/lvshouTrainCamp";
import LvshouMeiXueGuan from "@/components/Beauty/lvshouMeiXueGuan";

export default {
  name:'Beauty',
  data(){
    return{
      activeIndex:0,
      subMenu:['绿瘦训练营','绿瘦美学馆']
    }
  },
  components: {
    lvshouTrainCamp,
    LvshouMeiXueGuan
  },
  methods:{
    changeIndexFn(val){
      this.activeIndex = val;
    }
  },
  
}
</script>

<style lang="less">

</style>


